import { atom } from "recoil";
const adminState = atom({
  key: "isAdmin",
  default: false
});

export { adminState };